import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from "react-redux";
import DirectMessaging from "../direct_messaging/direct_messaging";
import {directMessageSetReceiverTagOwner} from "../../exhibition_actions";

export default function DirectMessagingPopup({data, onModalClose, hotspot}) {
  const dispatch = useDispatch()
  const isPreview = useSelector(state => state.isPreview)
  const isBoothEditor = useSelector(state => state.isBoothEditor)

  useEffect(() => {
    console.log("DISPATCH", data?.directMessagingData?.preselected_direct_message_tag_owner_id)
    if (data?.directMessagingData?.preselected_direct_message_tag_owner_id) {
      // Just fake the tag owner object, because the name shouldn't be displayed anyway
      // Sorry if someone has to implement this,  probably just implement a controller which fetches the tag owner object for this tag owner.
      dispatch(directMessageSetReceiverTagOwner({
        id: data?.directMessagingData?.preselected_direct_message_tag_owner_id,
        name: "",
        direct_messages_enabled: true
      }));
    }
  }, [])

  if (isPreview || isBoothEditor) {
    return null
  }

  // WITH THIS IT ALWAYS RERENDERS
  const ModalBody = () => {
    const isPreview = useSelector(state => state.isPreview)

    if (isPreview) {
      return <>
        <h4>Not available in preview</h4>
        <p>This is not available in the preview.</p>
      </>
    }
    return <DirectMessaging disableBackButton={data?.directMessagingData?.hide_back_button}  />;
  }

  return <div className="modal preview-modal" role="dialog" tabIndex="-1"
              onClick={() => {
                onModalClose ? onModalClose() : alert("No modal close action available.")
              }}>
    <div className="modal-dialog" role="document">
      <div className="modal-content" onClick={(event) => {
        event.stopPropagation()
      }}>
        <div className="modal-header">
          <div className="modal-title">
            {data.title}
          </div>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              onModalClose ? onModalClose() : alert("No modal close action available.")
            }}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <DirectMessaging
            disableBackButton={data?.directMessagingData?.hide_back_button == "true" || data?.directMessagingData?.hide_back_button == true}
          />
        </div>
      </div>
    </div>
  </div>;
}
